module.exports = __webpack_public_path__ + "img/down.11b6d13d.svg";